// ProductDetails.jsx
import React, { useEffect, useMemo } from 'react';
import './product-details-screen.scss';
import {
  ProductDetailsPageV1,
  ProductDetailsPageV2,
} from '@zonofi/zono-money-whatsapp-stack';
import {
  ConfigModule,
  getCustomerInvite,
  ProductDetailsPageView,
  useAppSelector,
  useGetConfigDetailsMutation,
} from '@zonofi/zono-money-store';
import { LoadingSpinner } from '@zonofi/zono-money-design-system';

export const ProductDetailsScreen = () => {
  const inviteData = useAppSelector(getCustomerInvite);
  const workspaceId = inviteData?.seller?.workspaceId;

  const [getConfigAPI, getConfigAPIResponse] = useGetConfigDetailsMutation();

  const pdpType = useMemo(() => {
    return (
      getConfigAPIResponse?.data?.config?.productDetailsPage ||
      ProductDetailsPageView.FacetView
    );
  }, [getConfigAPIResponse]);

  const ShowOutOfStack = useMemo(() => {
    return getConfigAPIResponse?.data?.config?.displayOutOfStock === true
      ? true
      : false;
  }, [getConfigAPIResponse]);

  useEffect(() => {
    getConfigAPI({
      workspaceId: workspaceId,
      module: ConfigModule.CATALOGUE,
      rollback: false,
    });
  }, [workspaceId]);

  if (getConfigAPIResponse?.isLoading) {
    return (
      <div className="product-details-loading">
        <LoadingSpinner />
      </div>
    );
  }

  switch (pdpType) {
    case ProductDetailsPageView.FacetView:
      return <ProductDetailsPageV1 showOutOfStack={ShowOutOfStack} />;
    case ProductDetailsPageView.VariantView:
      return <ProductDetailsPageV2 showOutOfStack={ShowOutOfStack} />;
    default:
      return <ProductDetailsPageV1 showOutOfStack={ShowOutOfStack} />;
  }
};
